<template>
    <div class="dispositivos-dashboard">
        <div style="background: #607D8B; color: #fff; padding: 5px 10px; border-bottom: 1px solid #122940">
            <el-row :gutter="20">
                <el-col :sm="12" :offset="0">
                    <h4 style="margin:10px 20px">DISPOSITIVOS MÉDICOS </h4>
                </el-col>

            </el-row>
        </div>
        <div class="dashboard-content">
            <el-row :gutter="20" style="padding: 20px;">
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="dashboard-card" @click="navigateTo('dispositivos-registros')">
                        <div class="card-content">
                            <i class="el-icon-document-add card-icon"></i>
                            <h3>Registros</h3>
                            <p>Gestionar registros de dispositivos médicos</p>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="dashboard-card" @click="navigateTo('dispositivos-convenios')">
                        <div class="card-content">
                            <i class="el-icon-document card-icon"></i>
                            <h3>Convenios</h3>
                            <p>Administrar convenios de dispositivos médicos</p>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="dashboard-card" @click="navigateTo('dispositivos-inventario')">
                        <div class="card-content">
                            <i class="el-icon-s-goods card-icon"></i>
                            <h3>Inventario</h3>
                            <p>Gestionar inventario de dispositivos</p>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="dashboard-card" @click="navigateTo('dispositivos-mantenimiento')">
                        <div class="card-content">
                            <i class="el-icon-s-tools card-icon"></i>
                            <h3>Mantenimiento</h3>
                            <p>Gestionar mantenimientos</p>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="dashboard-card" @click="navigateTo('dispositivos-reportes')">
                        <div class="card-content">
                            <i class="el-icon-s-data-analysis card-icon"></i>
                            <h3>Reportes</h3>
                            <p>Ver reportes y estadísticas</p>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="dashboard-card" @click="navigateTo('dispositivos-pruebas')">
                        <div class="card-content">
                            <i class="el-icon-s-platform card-icon"></i>
                            <h3>Pruebas</h3>
                            <p>Realizar pruebas del sistema</p>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="20" style="padding: 0 20px 20px;">
                <el-col :span="24">
                    <el-card>
                        <div slot="header">
                            <span>Resumen de Actividad - Dispositivos Médicos</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <div class="stat-card">
                                    <h4>Total Registros</h4>
                                    <p class="stat-number">{{ stats.totalRegistros || 0 }}</p>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="stat-card">
                                    <h4>Convenios Activos</h4>
                                    <p class="stat-number">{{ stats.conveniosActivos || 0 }}</p>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="stat-card">
                                    <h4>Inventario</h4>
                                    <p class="stat-number">{{ stats.totalInventario || 0 }}</p>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="stat-card">
                                    <h4>Mantenimientos</h4>
                                    <p class="stat-number">{{ stats.mantenimientosActivos || 0 }}</p>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosDashboard',
    data() {
        return {
            stats: {
                totalRegistros: 0,
                conveniosActivos: 0,
                totalInventario: 0,
                mantenimientosActivos: 0
            }
        }
    },
    methods: {
        navigateTo(routeName) {
            this.$router.push({
                name: routeName,
                query: { token: window.sessionStorage.getItem('token') }
            });
        },
        loadStats() {
            // Aquí se cargarían las estadísticas desde el backend
            // Por ahora usamos datos de ejemplo
            this.stats = {
                totalRegistros: 1250,
                conveniosActivos: 45,
                totalInventario: 53,
                mantenimientosActivos: 8
            };
        }
    },
    mounted() {
        this.loadStats();
    }
}
</script>

<style lang="scss" scoped>
:root {
    --color-primary: #122940;
    --color-primary-hover: #0d1f31;
    --color-border: #dbdbdb;
    --color-btn-primary: #2f4861;
    --color-btn-danger: #9d3434;
    --color-btn-nav: #b9b9b9;
    --color-surface-base: #ebebeb;
    --color-surface-alt: #cdcdcd;
    --color-surface-muted: #8d8d8d;
    --color-surface-muted-hover: #797979;
    --color-background-overlay: #000000d9;
    --color-background-overlay-secondary: #00000030;
    --color-btn-sign: #4da6ff2b;
    --color-feedback-success: #006300;
    --color-feedback-error: #930000;
    --color-background-input-login: #f7f7f7;
    --color-grey-input-login: #a5a5a5;
    --radius-xs: 2px;
    --radius-sm: 4px;
    --radius-md: 6px;
    --radius-lg: 8px;
    --radius-xl: 10px;
    --radius-2xl: 12px;
    --radius-12xl: 24px;
    --radius-full: 9999px;
}

.dispositivos-dashboard {
    padding: 0px;

    h2 {
        color: var(--color-primary);
        margin-bottom: 30px;
        font-weight: 600;
    }

    .dashboard-content {
        .dashboard-card {
            margin-bottom: 20px;
            cursor: pointer;
            transition: all 0.3s ease;
            border-radius: var(--radius-md);
            border: 1px solid var(--color-border);

            &:hover {
                transform: translateY(-5px);
                box-shadow: 0 8px 25px rgba(18, 41, 64, 0.2);
                border-color: var(--color-primary);
            }

            .card-content {
                text-align: center;
                padding: 20px;

                .card-icon {
                    font-size: 48px;
                    color: var(--color-primary);
                    margin-bottom: 15px;
                }

                h3 {
                    margin: 10px 0;
                    color: var(--color-primary);
                    font-weight: 500;
                }

                p {
                    color: var(--color-surface-muted);
                    margin: 0;
                }
            }
        }

        .stat-card {
            text-align: center;
            padding: 20px;

            h4 {
                color: var(--color-primary);
                margin-bottom: 10px;
                font-weight: 500;
            }

            .stat-number {
                font-size: 2.5em;
                font-weight: bold;
                color: var(--color-primary);
                margin: 0;
            }
        }
    }
}
</style>